'use client'

import React from 'react'

import { cn, stripParagraphTags } from '../../../../utils'

import { TextAButtons } from './a-text-a-buttons'

import type { IButtonProps } from '../../../../components/button/m-button'

export interface ITextAContentProps {
	title?: string
	content: string
	buttons?: IButtonProps[]
	className?: string
}

export const TextAContent: React.FC<ITextAContentProps> = ({
	title,
	content,
	buttons,
	className
}) => {
	// Strip <p> tags from headings for proper rendering
	const cleanTitle = title ? stripParagraphTags(title) : ''

	return (
		<div className={cn('m-text-a__content', className)}>
			{title && (
				<h2 className='m-text-a__title'>
					{cleanTitle.includes('<') ? (
						<span dangerouslySetInnerHTML={{ __html: cleanTitle }} />
					) : (
						cleanTitle
					)}
				</h2>
			)}

			<div className='m-text-a__text' dangerouslySetInnerHTML={{ __html: content }} />
			{buttons && buttons.length > 0 && <TextAButtons buttons={buttons} />}
		</div>
	)
}

TextAContent.displayName = 'ATextAContent'
